import React from 'react';
import { Icon, Row } from '@8base/boost';

export const ControlButton = ({ icon, label, active, empty, ...rest }) => (
  <Row alignItems="center" css={{ padding: '0 12px', fontWeight: 400, fontSize: 13, height: 36, borderColor: active ? '#d0d7dd' : 'transparent', backgroundColor: active || empty ? 'transparent' : '#F4F7F9', borderWidth: 1, borderStyle: 'solid', borderRadius: 4 }} { ...rest }>
    <Icon name={ icon } css={{ marginRight: 8 }} />
    { label }
  </Row>
);
